import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { createScheduledCommand } from 'ScheduledCommand/Domain/Services/CreateScheduledCommandService';
import { useParams } from 'react-router';
import { getScheduledCommand } from 'ScheduledCommand/Domain/Services/GetScheduledCommandService';
import { putScheduledCommand } from 'ScheduledCommand/Domain/Services/PutScheduledCommandService';
import DialogLoader from 'UI/Application/Components/Loaders/DialogLoader';
import { getCommands } from 'ScheduledCommand/Domain/Services/GetCommandsService';
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select } from '@mui/material';
import { PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS } from '../Constants/PathsConstant';
import { useTranslation } from 'react-i18next';

function FormScheduledCommandView() {
  const {t} = useTranslation();

  const {id} = useParams();
  
  const [description, setDescription] = useState('');
  const [commandArguments, setArguments] = useState('');
  const [cronExpression, setCronExpression] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [sendingApiRequest, setSendingApiRequest] = useState(false);

  const [selectedCommand, setSelectedCommand] = useState(null);
  const [getCommandsFlag, setGetCommandsFlag] = useState(true);
  const [commands, setCommands] = useState([]);

  useEffect(() => {
    if (id !== "new") {
      setSendingApiRequest(true);
      getScheduledCommand(id).then((response) => {
        setDescription(response.description);
        setSelectedCommand(response.command);
        setArguments(response.arguments);
        setCronExpression(response.cronExpression);
        setDisabled(response.disabled);
        setSendingApiRequest(false);
      });
    }
  }, [id]);

  useEffect(() => {
    if (getCommandsFlag) {
      setSendingApiRequest(true);
      getCommands().then((response) => {
        setCommands(response.commands);
        setGetCommandsFlag(false);
        setSendingApiRequest(false);
      });
    }
  }, [getCommandsFlag]);

  const handleCommandChange = (event) => {
    setSelectedCommand(event.target.value);
  };

  const handleDescriptionChange = (event) => setDescription(event.target.value);
  const handleArgumentsChange = (event) => setArguments(event.target.value);
  const handleCronExpressionChange = (event) => setCronExpression(event.target.value);
  const handleDisabledChange = (event) => setDisabled(event.target.checked);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      var apiResponse = null;
      if (sendingApiRequest) return;
      setSendingApiRequest(true);
      if (id === "new") {
        apiResponse = await createScheduledCommand({
          description: description,
          command: selectedCommand,
          arguments: btoa(commandArguments),
          cronExpression: btoa(cronExpression),
          disabled: disabled
        });
      } else {
        apiResponse = await putScheduledCommand(id, {
          description: description,
          command: selectedCommand,
          arguments: btoa(commandArguments),
          cronExpression: btoa(cronExpression),
          disabled: disabled
        });
      }
      setSendingApiRequest(false);
      if (apiResponse !== null) {
        window.location.href = process.env.PUBLIC_URL + PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS;
      }
    } catch (error) {
      //console.error(error);
    }
  };

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
      <h1>{id === "new" ? t('scheduledcommand.form.create') : t('scheduledcommand.form.update')}</h1>
      <form onSubmit={handleSubmit} style={{ width: '50%' }}>
        <TextField
          style={{ width: '100%' }}
          required
          label={t('scheduledcommand.form.description')}
          variant="outlined"
          value={description}
          onChange={handleDescriptionChange}
        />
        <br/><br/>
        <FormControl component="outlined" style={{ width: '100%' }}>
          <InputLabel htmlFor="select-command">Comando</InputLabel>
          <Select
            id="select-command"
            value={selectedCommand}
            label={t('scheduledcommand.form.command')}
            required
            onChange={handleCommandChange}
          >
            {commands ? commands.map((command) => (
              <MenuItem key={command} value={command}>{command}</MenuItem>
            )) : <></>}
          </Select>
        </FormControl>
        <br/><br/>
        <TextField
          style={{ width: '100%' }}
          label={t('scheduledcommand.form.arguments')}
          variant="outlined"
          value={commandArguments}
          onChange={handleArgumentsChange}
        />
        <br/><br/>
        <TextField
          style={{ width: '100%' }}
          required
          label={t('scheduledcommand.form.cronExpression')}
          variant="outlined"
          value={cronExpression}
          onChange={handleCronExpressionChange}
        />
        <br/><br/>
        <legend>{t('scheduledcommand.form.disabled')}</legend>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={disabled} onChange={handleDisabledChange} value={disabled} />}
          />
        </FormGroup>
        <br/><br/>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <Button variant="contained" color="primary" type="submit">
            {id === "new" ? t('scheduledcommand.form.create') : t('scheduledcommand.form.update')}
          </Button>
          <Button variant="contained" color="error" href={process.env.PUBLIC_URL + PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS}>
            {t('scheduledcommand.form.cancel')}
          </Button>
        </Box>
      </form>
      <DialogLoader open={sendingApiRequest} />
    </Box>
  );
}

export default FormScheduledCommandView;
